import header_baner from "../../../assets/images/header_baner.svg";
import logo from "../../../assets/images/logo.svg";

export default function Section1() {
    return (
        <section className="section1">
            <div className="flex flex-col justify-center items-center relative max-w-full">
                <img
                    src={header_baner}
                    alt="baner"
                    className="h-[131px] w-[1476px] mx-auto overflow-hidden object-cover"
                />
                <div className="bg-[#fff] w-[490px] h-[490px] absolute top-[-90px] left-1/2 transform -translate-x-1/2 z-10 rounded-full overflow-hidden flex justify-center items-end"
                >
                    <div className="fle flex-col">
                        <img src={logo} alt="logo" width={220} height={77} />
                        <div className="flex flex-col items-center gap-[18px] mt-[53px] mb-[58px]">
                            <p className="uppercase cursor-pointer text-[#000000] hover:opacity-70 font-bold text-center text-[15px]"
                                onClick={() => document.getElementById('what-we-do').scrollIntoView({ behavior: "smooth", duration: 500 })}
                            >What we do</p>
                            <p className="uppercase cursor-pointer text-[#000000] hover:opacity-70 font-bold text-center text-[15px]"
                                onClick={() => document.getElementById('vacancies').scrollIntoView({ behavior: "smooth", duration: 500 })}
                            >vacancies</p>
                            <p className="uppercase cursor-pointer text-[#000000] hover:opacity-70 font-bold text-center text-[15px]"
                                onClick={() => document.getElementById('contacts').scrollIntoView({ behavior: "smooth", duration: 500 })}
                            >Contacts</p>
                        </div>
                    </div>
                </div>
                <div className="flex w-full justify-center items-center overflow-hidden">
                    <div className="bg-[#71AD80] h-[30px] w-full rounded-tr-[5px]">
                    </div>
                    <div className="!w-[490px] h-[30px] flex-none"></div>
                    <div className="bg-[#71AD80] h-[30px] w-full rounded-tl-[5px]">
                    </div>
                </div>
            </div>
        </section>);
}